// extracted by mini-css-extract-plugin
export default {"container":"styles_container__cod8q","content":"styles_content__H-dCC","open":"styles_open__LvK9u","closed":"styles_closed__YFAmI"};